<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.031 512.031" class="fill-current">
    <path
      d="M154.542 312.223L57.39 409.375.046 351.969V512h160l-57.375-57.375 97.152-97.152zM352.015 0l57.375 57.375-97.121 97.121 45.25 45.312 97.152-97.183L512.015 160V0zM154.542 199.747l45.251-45.251-97.122-97.121L160.015 0h-160v160l57.344-57.375zM357.519 312.253l-45.25 45.251 97.121 97.121-57.375 57.406h160V351.969l-57.344 57.442z"
    />
  </svg>
</template>
